import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Layout, Menu, Dropdown, Modal } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { logout } from "./service";
import styles from "./index.module.less";
import "moment/locale/zh-cn";

moment.locale("zh-cn");
const { Header } = Layout;

export default function LayoutComponent(props) {
  const navigate = useNavigate();
  React.useEffect(() => {
    // props.getUserInfo();
  }, []);
  const { userInfo } = useSelector((state) => state.userInfo);
  const onLogout = () => {
    Modal.confirm({
      title: "操作提示",
      content: "正在进行退出操作，是否继续？",
      onOk: async () => {
        const res = await logout();
        if (res.code === 0) {
          navigate("/login", { replace: true });
        }
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };
  const menu = (
    <Menu>
      <Menu.Item key="3" onClick={onLogout}>
        退出登录
      </Menu.Item>
    </Menu>
  );

  return (
    <main className={styles["layout-main"]}>
      <Layout style={{ minHeight: "100vh" }}>
        <Header className={["header-outer"]}>
          <div className="header-logo-outer">
            <span style={{ color: "#fff" }}>{userInfo.supermarketName}</span>
          </div>
          <div className="header-userInfo-outer">
            <Dropdown overlay={menu}>
              <a
                className="ant-dropdown-link"
                onClick={(e) => e.preventDefault()}
              >
                <span style={{ color: "#fff" }}>
                  {userInfo.roleName} - {userInfo.userName}
                </span>{" "}
                <DownOutlined />
              </a>
            </Dropdown>
          </div>
        </Header>
        <Layout style={{ height: "calc(100vh - 45px)", overflow: 'hidden' }}>
          <Outlet />
        </Layout>
      </Layout>
    </main>
  );
}
